// Configuration centralisée des liens sociaux
// Tous les liens sont récupérés depuis les variables d'environnement

const socialLinks = {
  // Liens principaux
  twitter: import.meta.env.VITE_TWITTER_URL || 'https://x.com/anivyo93473',
  facebook: import.meta.env.VITE_FACEBOOK_URL || 'https://www.facebook.com/profile.php?id=61581075894647',
  linkedin: import.meta.env.VITE_LINKEDIN_URL || 'https://www.linkedin.com/in/ainivyo-ai-4b9b48384/',
  github: import.meta.env.VITE_GITHUB_URL || 'https://github.com/ANIVYO',
  instagram: import.meta.env.VITE_INSTAGRAM_URL || 'https://www.instagram.com/anivyo_ai/',
  youtube: import.meta.env.VITE_YOUTUBE_URL || 'https://www.youtube.com/@anivyo_ai',
  tiktok: import.meta.env.VITE_TIKTOK_URL || 'https://www.tiktok.com/@anivyo_ai',
  telegram: import.meta.env.VITE_TELEGRAM_URL || 'https://t.me/anivyo_bot',
  discord: import.meta.env.VITE_DISCORD_URL || '#',
  
  // Liens alternatifs (pour compatibilité)
  linkpage: {
    twitter: import.meta.env.VITE_LINKPAGE_TWITTER || 'https://x.com/anivyo93473',
    facebook: import.meta.env.VITE_LINKPAGE_FACEBOOK || 'https://www.facebook.com/profile.php?id=61581075894647',
    linkedin: import.meta.env.VITE_LINKPAGE_LINKEDIN || 'https://www.linkedin.com/in/ainivyo-ai-4b9b48384/',
    github: import.meta.env.VITE_LINKPAGE_GITHUB || 'https://github.com/ANIVYO',
    instagram: import.meta.env.VITE_LINKPAGE_INSTAGRAM || 'https://www.instagram.com/anivyo_ai/',
    youtube: import.meta.env.VITE_LINKPAGE_YOUTUBE || 'https://www.youtube.com/@anivyo_ai',
    tiktok: import.meta.env.VITE_LINKPAGE_TIKTOK || 'https://www.tiktok.com/@anivyo_ai',
    telegram: import.meta.env.VITE_LINKPAGE_TELEGRAM || 'https://t.me/anivyo_bot',
    discord: import.meta.env.VITE_LINKPAGE_DISCORD || '#',
  }
};

export default socialLinks;
